import type { Prismic } from '@landsbankinn/prismic';
import {
  fallbackText,
  getDataFromLink,
  isEmptyText,
  PrismicLink,
  PrismicText,
} from '@landsbankinn/prismic';
import { ArrowButton, Segment } from '@landsbankinn/ui';
import React from 'react';
import { Intro } from '../components/intro/Intro';
import { PageIntro } from '../components/intro/PageIntro';

interface IProps {
  title?: Prismic.RichText;
  copy: Prismic.RichText;
  copy_size: boolean;
  link?: Prismic.Link;
  link_text: Prismic.RichText;
  template: string;
}

export const IntroTextContainer = ({
  title,
  copy,
  copy_size,
  link,
  link_text,
  template,
}: IProps) => {
  if (isEmptyText(copy)) {
    return null;
  }

  const isArticle = template === 'article';

  const linkdata = getDataFromLink(link);
  const linkText = fallbackText(link_text, linkdata.title ?? undefined);

  const action = link ? (
    <PrismicLink value={link} title={linkText ?? undefined}>
      <ArrowButton title={linkText ?? ''} isSmall />
    </PrismicLink>
  ) : null;

  if (isArticle) {
    return (
      <Segment isArticle={isArticle}>
        <Intro>
          <PrismicText value={copy} />
        </Intro>
      </Segment>
    );
  }

  return (
    <Segment className={'intro'}>
      <PageIntro
        title={<PrismicText value={title} />}
        copy={<PrismicText value={copy} />}
        copySize={copy_size}
        action={action}
      />
    </Segment>
  );
};
